export default "__VITE_ASSET__DFpxNvD___"